import React, {ReactElement, useState, useMemo, useCallback, useEffect, useContext} from 'react';
import Head from 'next/head';
import Error from 'next/error';
import { useRouter } from 'next/router';

import MainLayout from 'components/layout/mainLayout';
import SearchPage from 'components/pages/search/searchPage';

import seo from 'utils/seo';

import getTemplateData from 'utils/getTemplateData';
import storyblokService from 'services/storyblokService.js';

import {SearchContext} from 'services/searchService';

// Test 2

type Props = {
  statusCode: number,
  error?: any,
  masterTemplateData: any,
  pageData: any,
  catData: any,
  searchResults: Product[],
  searchMeta: SearchMeta,
  params: any,
  query: any
};


// Product Search Page
const Page: NextPageExtended<Props> = (props) => {

  const router = useRouter()
  const search = useContext(SearchContext)

  // State
  const [sideBarIsOpen, setSidebarIsOpen] = useState(false)

  // Get content from supplied StoryBlok story
  const content = useMemo(() => {
    return props.pageData?.content;
  }, [props.pageData]);

  const seoContent = content?.seo;


  // Route Change
  useEffect(() => {

    console.log("search.parseUrl", search)

    if(search.parseUrl){
      search.parseUrl();
    }

  }, [router.query]);

    
  // Toggle Sidebar
  const toggleSidebar = useCallback(() => {
      setSidebarIsOpen(!sideBarIsOpen);
  }, [sideBarIsOpen]);

  
  // Errors
  if (props.statusCode > 299) {
    return <Error statusCode={props.statusCode} />;
  }

  return (

    <>
    
      <Head>
        <title>{seo.createTitle(seoContent?.title)}</title>
        <meta name="description" content={seoContent?.description} />
      </Head>

      <SearchPage 
        pageData={props.pageData} 
        catData={props.catData} 
        sideBarIsOpen={sideBarIsOpen} 
        toggleSidebar={toggleSidebar}
      />
      
    </>
  
  );

}


// Server Side Props
export async function getServerSideProps({ params, query, preview = false, previewData = {} }) {

  let statusCode = 200;

  // Get Data
  let results;

  // Construct queries
  let queries = [
      getTemplateData(),                            
      storyblokService.get(`cdn/stories/products/`, {})       // Just the page info, not the actual products.
  ];

  if(query?.cat_id){
    queries.push(storyblokService.get(`cdn/stories/${query?.cat_id}`, {}));
  }

  try {
    results = await Promise.all(queries);
  } catch (error) {
    return {
      // revalidate: 1, 
      props: { 
        statusCode: error.response ? error.response.status : 500,
        error: error
      }
    }
  }

  const masterTemplateData = results[0] ?? null;
  const pageData = results[1]?.data?.story ?? null;

  // Hack because last items keeps going missing
  masterTemplateData.content.top_menu_categories.push({});

  let catData = null;
  if(query?.cat_id){
    catData = results[2]?.data?.story;
  }

  // Return props
  return {
    // revalidate: 1,
    props: {
      statusCode,
      masterTemplateData,
      pageData: pageData ?? null,
      catData: catData ?? null,
      // searchResults,
      // searchMeta,
      params: params ?? null,
      query: query ?? null
    }
  }

}


Page.getLayout = (page: ReactElement) => {
  return (
    <MainLayout masterTemplateData={page.props.masterTemplateData}>
      {page}
    </MainLayout>
  );
}

export default Page

